const duplicateTranslationKey = (key: string): string => key;

export const translationStatistics_en_part3 = {
  statisticsSettings: "Statistics Settings",
  statisticsVisibility: "Statistics Visibility",
  statisticsVisibilityDescription:
    "Choose which statistics to display on the main statistics page. Changes are saved automatically.",
  aiStatistics: "AI Statistics",
  // Topics management (Emner)
  // Topics management (Emner)
  conversations: "conversations",
  topicsManagementTitle: "Topics",
  topicsManagementDescription:
    "Manage the topics the AI uses to categorize conversations. The description guides the AI's classification.",
  topicsSelectSingleChatbot: "Select a single chatbot to manage topics.",
  topicsInheritedBanner: "Topics are inherited from the parent chatbot.",
  topicsCustomize: "Customize",
  topicsCustomized: "Topics were copied and can now be customized.",
  topicsLoadError: "Could not load topics",
  topicName: "Name",
  topicDescriptionLabel: "Description",
  topicDescriptionHint: "Add description...",
  topicAdd: "Add topic",
  topicNewNamePlaceholder: "New topic...",
  topicNewDescriptionPlaceholder: "Description (optional)",
  topicCreated: "Topic created",
  topicDeleted: "Topic deleted",
  topicDelete: "Delete topic",
  topicArchivedBadge: "Archived",
  topicMergeExplanation:
    "Choose which topic its conversations move to - then the topic is deleted.",
  topicMergeTargetLabel: "Move conversations to",
  topicMergeConfirm: "Move and delete",
  topicDeleteConfirmTitle: "Delete topic?",
  topicDeleteConfirmDescription:
    "The topic has no conversations attached and will be removed permanently.",
  topicNoTopics: "No topics yet. Add a topic below.",
  topicsScopeOrg: "Shared across the organization",
  topicsScopeBrand: "Brand-specific topics",
  topicsScopeChatbot: "This chatbot only",
  topicsCustomizeForChatbot: "Customize for this chatbot only",
  topicsCustomizeForBrand: "Customize for this brand",
  topicsBrandUsesOrg: "This brand uses the organization's shared topics.",
  topicSubtagsLabel: "Tags",
  topicSubtagsHint: "Tags the AI may use for this topic (tags(...)).",
  topicAddTagPlaceholder: "Add tag...",
  topicRemoveTag: "Remove tag",
  freshdeskTagsTitle: "Freshdesk tags",
  freshdeskTagsDescription: "Tags the AI may put on Freshdesk tickets via email automation.",
  livechatStatistics: "Live Chat Statistics",
  // Live Chat Statistics individual translations
  // Live Chat Statistics individual translations
  totalLivechatConversations: "Total livechat conversations",
  avgLivechatPerDay: "Average livechat per day",
  livechatPercentage: "Livechat percentage",
  avgResponseTime: "Average response time",
  totalResponses: "Total responses",
  livechatStatisticsDescription:
    "Track livechat volume, response times, and customer feedback for the selected chatbots.",
  dailyLivechatSessions: "Daily livechat sessions",
  livechatSessionsByHour: "Livechat sessions by time of day",
  livechatStatusDistribution: "Status distribution",
  livechatStatusWaiting: "Waiting",
  livechatStatusActive: "Active",
  livechatStatusClosed: "Closed",
  livechatWaitingSessions: "Waiting sessions",
  livechatActiveSessions: "Active sessions",
  livechatClosedSessions: "Closed sessions",
  avgWaitTime: "Average wait time",
  avgHandlingTime: "Average handling time",
  livechatTotalRatings: "Livechat ratings",
  viewLivechatSessions: "View livechat sessions",
  noLivechatStatistics: "No livechat statistics found for the selected period.",
  // Live Chat Statistics tooltips
  // Live Chat Statistics tooltips
  totalLivechatConversationsTooltip: "Total number of conversations handled through live chat",
  avgLivechatPerDayTooltip: "Average number of live chat conversations per day",
  livechatPercentageTooltip: "Percentage of all conversations that went to live chat",
  avgResponseTimeTooltip: "Average time for agents to respond to user messages",
  totalResponsesTooltip: "Total number of responses sent by agents in live chat",
  livechatWaitingSessionsTooltip: "Number of livechat sessions waiting for an agent",
  livechatActiveSessionsTooltip: "Number of livechat sessions that are currently active",
  livechatClosedSessionsTooltip: "Number of completed livechat sessions",
  avgWaitTimeTooltip: "Average time from livechat request until an agent joins",
  avgHandlingTimeTooltip: "Average time from agent join until the livechat session is closed",
  livechatTotalRatingsTooltip: "Number of customer ratings submitted after livechat sessions",
  save: "Save",
  [duplicateTranslationKey("cancel")]: "Cancel",

  // Notifications page

  // Notifications page
  notificationsPageTitle: "Notifications",
  notificationsPageDescription:
    "Set up automatic email notifications when there is unusual activity on your chatbot. Select a topic, specify what percentage increase should trigger the notification, and set the time period for measurement. You will receive an email when activity exceeds the specified percentage increase compared to normal activity in the selected period.",
  notificationsLabelTopic: "Topic",
  notificationsLoadingTopics: "Loading topics...",
  notificationsSelectTopic: "Select a topic",
  notificationsNoTopics:
    "No topics found. Topics are generated automatically from your conversations.",
  notificationsLabelPercentIncrease: "Percentage Increase",
  notificationsSelectPercent: "Select percentage increase",
  notificationsLabelTimePeriod: "Time Period",
  notificationsSelectTimePeriod: "Select time period",
  notificationsPeriod6Hours: "6 hours",
  notificationsPeriod12Hours: "12 hours",
  notificationsPeriod24Hours: "24 hours",
  notificationsPeriod3Days: "3 days",
  notificationsPeriod7Days: "7 days",
  notificationsLabelEmail: "Email",
  notificationsEmailPlaceholder: "Enter email address",
  notificationsSaving: "Saving...",
  notificationsSaveButton: "Save Notification Settings",
  notificationsYourSettings: "Your Notification Settings",
  notificationsLoadingSettings: "Loading settings...",
  notificationsNoSettings: "You have no active notification settings yet.",
  notificationsCreateFirst: "Create your first notification above.",
  notificationsCardTopic: "Topic",
  notificationsCardIncrease: "Increase",
  notificationsCardPeriod: "Period",
  notificationsCardEmail: "Email",
  notificationsCreatedAt: "Created",
  notificationsDeleteButton: "Delete",
  notificationsDeleteTitle: "Delete notification",
  notificationsErrorFetchTopics: "Error fetching topics",
  notificationsErrorFetchSettings: "Error fetching notification settings",
  notificationsSaveSuccess: "Notification settings saved successfully",
  notificationsSaveError: "Error saving settings",
  notificationsLoginRequired: "You must be logged in to delete notifications",
  notificationsDeleteSuccess: "Notification setting deleted successfully",
};
